import { createContext } from 'react';

var _createContext = createContext({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

export { Consumer, Provider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/node_modules/@atlaskit/theme/dist/esm/components/Context.js
// module id = 100
// module chunks = 0